import BasicLayout from "../../layout/curr.vue"
// const pre = ' - 极客轻商城系统';
const meta = {
  auth: true
};

export default {
  path: 'setting',
  name: 'setting',
  component: BasicLayout,
  children: [{
      path: 'base',
      name: "setting-base",
      component: () => import("@/pages/admin/setting/setting-base.vue"),
      meta: {
        ...meta,
        title: '基础配置 - 极客商城系统'
      }

    },{
      path: 'theme',
      name: "setting-theme",
      component: () => import("@/pages/admin/setting/setting-theme.vue"),
      meta: {
        ...meta,
        title: '主题配置 - 极客商城系统'
      }

    }, {
      path: 'email',
      name: "setting-email",
      component: () => import("@/pages/admin/setting/setting-email.vue"),
      meta: {
        ...meta,
        title: '邮箱配置 - 极客商城系统'
      }

    }, {
      path: 'sms',
      name: "setting-sms",
      component: () => import("@/pages/admin/setting/setting-sms.vue"),
      meta: {
        ...meta,
        title: '短信配置 - 极客商城系统'
      }

    }, {
      path: 'upload',
      name: "setting-upload",
      component: () => import("@/pages/admin/setting/setting-upload.vue"),
      meta: {
        ...meta,
        title: '上传配置 - 极客商城系统'
      }

    }, {
      path: 'swipe',
      name: "setting-swipe",
      component: () => import("@/pages/admin/setting/setting-swipe.vue"),
      meta: {
        ...meta,
        title: '轮播图配置 - 极客商城系统'
      }

    }, {
      path: 'pay',
      name: "setting-pay",
      component: () => import("@/pages/admin/setting/setting-pay.vue"),
      meta: {
        ...meta,
        title: '支付配置 - 极客商城系统'
      }
    },
    {
      path: "*",
      redirect: '/home'
    },

  ]
};